import React from "react";
import { Form, Field } from "react-final-form";
import Modal from "components/Modal/Modal";
import ModalBody from "components/Modal/ModalBody";
import ModalFooter from "components/Modal/ModalFooter";
import ModalFooterLeft from "components/Modal/ModalFooterLeft";
import ModalFooterRight from "components/Modal/ModalFooterRight";
import Button from "components/Button/Button";
import { Card } from "components/CreditCards";
import * as FormUtils from "common/FormUtils";
import { httpClient } from "common/httpClient";
import { FORM_ERROR } from "final-form";

const UpdateCardExpiryModal = ({ close, card }) => {
    const submitCard = async (expiryDate) => {
        try {
            const [year, month] = expiryDate.month.split("-");
            const date = new Date(Number(year), Number(month), 1);
            await httpClient.post(`payments/updatePaystationToken`, { tokenId: card.id, expiryDate: date });
            close();
        } catch (ex) {
            console.error("Error fetching payment data:", ex);
            return { [FORM_ERROR]: ex.message || "Update failed. Please try again." };
        }
    };

    const month = new Date().getMonth();

    return (
        <Form
            onSubmit={submitCard}
            validate={(values) => {
                const errors = {};
                errors.month = FormUtils.validators.required(values.month);
                return errors;
            }}
            render={({ form, handleSubmit, submitting, submitError }) => {
                const currentMonth = String(month + 1).padStart(2, "0");
                const minMonth = `${new Date().getFullYear()}-${currentMonth}`;
                return (
                    <form onSubmit={handleSubmit}>
                        <Modal title="Update expiry date" skinny close={close} submitting={submitting}>
                            <ModalBody>
                                <div className="u-flex u-flexAlignItemsCenter u-flexColumn u-mb-m u-mt-xl">
                                    <div className="u-mb-md">
                                        <Card card={card} />
                                        <Field name="month" min={minMonth}>
                                            {({ input, meta }) => (
                                                <div className={`Field ${meta?.touched && meta?.error ? "has-error" : ""}`}>
                                                    <label className="Field-label">New expiry date</label>
                                                    <div className="Input_wrapper">
                                                        <input {...input} type="month" style={{ padding: "10px" }} min={minMonth} />
                                                    </div>
                                                    {meta.error && meta.touched && <small className="Field-error">{meta.error}</small>}
                                                </div>
                                            )}
                                        </Field>
                                        {submitError && <div className="u-font-red u-mt-sm">{submitError}</div>}
                                    </div>
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <ModalFooterLeft>
                                    <Button id="cancel" onClick={close} secondary disabled={submitting}>
                                        Cancel
                                    </Button>
                                </ModalFooterLeft>
                                <ModalFooterRight>
                                    <Button id="submit" submit primary disabled={submitting}>
                                        Update
                                    </Button>
                                </ModalFooterRight>
                            </ModalFooter>
                        </Modal>
                    </form>
                );
            }}
        />
    );
};
export default UpdateCardExpiryModal;
